var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("option-field", {
    staticClass: "_mt-0",
    attrs: {
      "display-name": _vm.Resources.Layout.ThemeSelectorLabel,
      options: _vm.themeOptions,
      "has-transparent-bg": _vm.hasTransparentBg,
      name: "theme-selector",
      layout: "condensed",
      "data-qa": "footer-theme-dropdown",
    },
    scopedSlots: _vm._u(
      [
        {
          key: "label",
          fn: function () {
            return [_vm._t("default")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }